// import moment from 'moment';
// import Base from './base';
/* eslint camelcase: 0 */
export default class menuSection {
  constructor({ enable = false, name = '' } = {}) {
    this.name = name;
    this.enable = enable;
  }
}
